import React from 'react';
import {useTranslation} from 'react-i18next';
import {SingleComponentStatus, StatusDefect, StatusDefectGroup} from '../../../../services/componentStatus';
import {StyledStatusPicker} from './singleComponents.style';
import {StyledInput} from '../../../../components/form/input/input.style';
import {StyledCircleButton} from '../../../../components/button/button.style';
import ArrowDownImage from '../../../../assets/images/down-arrow.svg';
import CloseImage from '../../../../assets/images/e-remove.svg';
import {ThumbDownRedImage, ThumbUpYellowImage} from '../../../../utils/styles/icons';

export type SingleComponentStatusPickerProps = {
    status: SingleComponentStatus;
    reworkedEnabled: boolean;
    defectGroup?: StatusDefectGroup;
    reportPreview: boolean;
    formSubmitted: boolean;
    canEditDefects: boolean;
    onStatusToggle: (status: Exclude<SingleComponentStatus, 'ok'>) => void;
    onSelectDefect: (defectIndex: number, defect: StatusDefect) => void;
    onRemoveDefect: (defectIndex: number) => void;
    onAddDefect: () => void;
};

const SingleComponentStatusPicker: React.FC<SingleComponentStatusPickerProps> = (props) => {
    const {t} = useTranslation();
    const defects = props.defectGroup?.defects ?? [];

    return <StyledStatusPicker>
        <div className="status-buttons">
            <button type="button" disabled={props.reportPreview}
                    className={'status-button nok report-row-component-defects-not-repaired-single' + (props.status === 'nok' ? ' selected' : '')}
                    onClick={() => !props.reportPreview && props.onStatusToggle('nok')}>
                <img src={ThumbDownRedImage} alt=""/>
                {t('reportPage.reportForm.defects.nok')}
            </button>

            {props.reworkedEnabled &&
                <button type="button" disabled={props.reportPreview}
                        className={'status-button reworked report-row-component-defects-repaired-single' + (props.status === 'reworked' ? ' selected' : '')}
                        onClick={() => !props.reportPreview && props.onStatusToggle('reworked')}>
                    <img src={ThumbUpYellowImage} alt=""/>
                    {t('reportPage.reportForm.defects.ok')}
                </button>
            }
        </div>

        {props.status !== 'ok' && props.canEditDefects && <>
            {defects.map((defect, defectIndex) =>
                <div className="defect-row" key={'single_defect_' + defectIndex}>
                    <div className="select-wrap" onClick={() => {
                        if (!props.reportPreview) {
                            props.onSelectDefect(defectIndex, defect);
                        }
                    }}>
                        <StyledInput readOnly={true}
                                     className={'report-row-component-defect-name' + (props.formSubmitted && !defect.name && !defect.other ? ' hasErrors' : '')}
                                     value={defect.name || defect.other || ''}
                                     placeholder={t('common.select')}/>
                        <img className="down" src={ArrowDownImage} alt=""/>
                    </div>
                    {!props.reportPreview &&
                        <StyledCircleButton className="white" onClick={() => props.onRemoveDefect(defectIndex)}>
                            <img src={CloseImage} alt=""/>
                        </StyledCircleButton>
                    }
                </div>
            )}

            {!props.reportPreview &&
                <button type="button" className="add-defect report-row-component-add-additional-defect" onClick={() => props.onAddDefect()}>
                    {t('reportPage.reportForm.addDefect')}
                </button>
            }
        </>}
    </StyledStatusPicker>;
};

export default SingleComponentStatusPicker;
